import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: "supply";
    src: url("/supply-regular.otf");
  }
  @font-face {
    font-family: "supply-light";
    src: url("/supply-ultralight.otf");
    font-weight: 300;
  }
  @font-face {
    font-family: "neue-haas-grotesk-display-bold";
    font-weight: 700;
    font-style: normal;
  }

  body {
    font-family: "neue-haas-grotesk-display", sans-serif;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
  }

  @keyframes scaleIn { 
    0% { 
      transform: scale(1);
    } 
    100% { 
      transform: scale(1.1);
    } 
  }
  @keyframes scaleOut { 
    0% { 
      transform: scale(1.1);
    } 
    100% { 
      transform: scale(1);
    } 
  }

  :focus {
    outline-color: ${({ theme }) => theme.colours.blue};
  }
`;

export default GlobalStyle;
